import { spacing } from "@minuthq/meatball-ui-react"

import { EmptyStateWithImage } from "src/components/EmptyState/EmptyStateWithImage"
import { useTranslate } from "src/i18n/useTranslate"

import NoAiSuggestionsImage from "./images/suggestions-empty-state.svg"

export function NoAiSuggestions() {
  const { tPlaceholder } = useTranslate()

  return (
    <EmptyStateWithImage
      Image={NoAiSuggestionsImage}
      title={tPlaceholder("No suggestions yet")}
      description={tPlaceholder(
        "Autopilot reviews your manual replies and suggests what to add to your Knowledge. Once there’s something to review, you’ll find it here."
      )}
      imageSpacing={spacing.M}
      limitImageWidth={false}
    />
  )
}
